// Les trois flux lisent trois DTO différents pour désigner "la commande" d'une carte
// (PlanningSousTraitanceDTO côté confection, CommandeDelavageDTO côté délavage, Commande générique
// côté finition) : ce module normalise leur lecture en un seul endroit plutôt que de deviner le
// bon champ à trois endroits différents de l'écran.
export function libelleCommande(c) {
  return {
    numero: c.numeroCommande || c.commandeNumeroCommande || '',
    modele: c.modele?.name || c.modele?.nom || c.commandeModeleName || c.modeleName || '',
    client: c.client?.name || c.client?.nom || c.clientName || c.commandeClientName || '',
    marque: c.marque?.name || c.marque?.nom || c.marqueName || c.commandeMarqueNom || '',
    qte: c.qte ?? c.commandeQte ?? '',
    imageUrl: c.imageUrl || c.commandeImageModeleFileUrl || c.imageUrlFace || c.imageModele?.fileUrl || null,
  };
}
